module.exports = __webpack_public_path__ + "static/media/stadion_large.40a35ae3.jpg";